import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';

const linkCls = ({ isActive }: { isActive: boolean }) =>
  `rounded-md px-3 py-2 text-sm font-medium ${
    isActive ? 'bg-[#0B1F4A] text-white' : 'text-gray-600 hover:bg-gray-100'
  }`;

export const CierreLayout: React.FC = () => {
  return (
    <div>
      <nav className="mb-6 flex flex-wrap gap-2 border-b border-gray-200 pb-4">
        <NavLink to="/cierre" end className={linkCls}>
          Cierre diario
        </NavLink>
        <NavLink to="/cierre/mensual" className={linkCls}>
          Cierre mensual
        </NavLink>
        <NavLink to="/cierre/anual" className={linkCls}>
          Cierre anual
        </NavLink>
      </nav>
      <Outlet />
    </div>
  );
};
